var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.72 97.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bccampus-icon-cls-1{fill:#a6def4;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bccampus-icon-cls-1",
    d: "M106.12,43.82,90.38,57.05A23.78,23.78,0,1,1,72,48.34h4.23V57.5L100,38.08,76.23,18.64v9.13H72a44.42,44.42,0,1,0,34.14,16.05Z",
    transform: "translate(-27.64 -18.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4d6bd6a108ae2958ca0af9e3f5a669f1.svg";
export { ForwardRef as ReactComponent };